import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sum'
})
export class SumPipe implements PipeTransform {
    transform(items: any[], attr: string): any {
        if (items == null) {
            return 0;
        }
        return items.reduce( function(a, b){
            return a + b[attr];
        }, 0);
    }
}


// WEBPACK FOOTER //
// ./src/pipes/sum.pipe.ts